import React from "react";

export const HandoffMarker = () => {
  return (
    <marker
      id="handoff"
      viewBox="0 0 50 50"
      refX="6"
      refY="9"
      markerWidth="50"
      markerHeight="50"
      orient="auto-start-reverse"
    >
      <rect x="0" y="0" width={1} height={18} fill="#000" />
    </marker>
  );
};
